import { useQuery } from '@tanstack/react-query';

import { normalizeToStartOfDayUTC } from '@/utils/date-formatters';

import { getBillMonthlySalaryAvailability } from '../api';

export const BILL_MONTHLY_SALARY_AVAILABILITY_QUERY_KEY = [
  'bill-monthly-salary-availability',
] as const;

export const useBillMonthlySalaryAvailability = ({
  memberId,
  startDate,
  endDate,
  currencyCode,
}: {
  memberId: number | undefined;
  startDate: Date | undefined;
  endDate: Date | undefined;
  currencyCode: string;
}) =>
  useQuery({
    queryKey: [
      ...BILL_MONTHLY_SALARY_AVAILABILITY_QUERY_KEY,
      memberId,
      startDate?.getTime(),
      endDate?.getTime(),
      currencyCode,
    ],
    queryFn: () =>
      getBillMonthlySalaryAvailability({
        memberId: memberId as number,
        startDate: normalizeToStartOfDayUTC(startDate as Date).toISOString(),
        endDate: normalizeToStartOfDayUTC(endDate as Date).toISOString(),
        currencyCode,
      }),
    enabled: Boolean(memberId && startDate && endDate && currencyCode),
  });
